import clsx from "clsx"

import type { GetButtonClassesTW } from "./types"

export const getButtonClasses: GetButtonClassesTW = ({
  size,
  baseVariant,
  disabled,
  contentInvisible,
  LeftIcon,
  RightIcon,
  hasPadding,
}) => {
  return {
    container: clsx(
      "relative box-border w-fit rounded-full outline-none transition-colors ease-in-out",
      "inline-flex flex-row flex-nowrap items-center justify-center gap-1",
      "focus-visible:outline-1 focus-visible:outline-primary-700",
      !disabled ? "cursor-pointer" : "cursor-default",
      contentInvisible && "[&>*]:invisible",
      {
        large: clsx(hasPadding ? "h-12 px-8" : "-mx-1 px-1"), // "-mx" increases outline-offset-x
        medium: clsx(hasPadding ? "h-10 px-6" : "-mx-1 px-1"),
        small: clsx(hasPadding ? "h-8 px-4" : "hidden"),
      }[size],
      {
        primary: [
          !disabled && ["bg-primary-700 text-white", "hover:bg-primary-800", "active:bg-primary-900"],
          disabled && "bg-neutral-300 text-neutral-700",
        ],
        secondary: [
          "border",
          !disabled && [
            "border-primary-700 bg-transparent text-primary-700",
            "hover:border-primary-800 hover:bg-primary-100 hover:text-primary-800",
            "active:border-primary-900 active:bg-primary-200 active:text-primary-900",
          ],
          disabled && "border-neutral-400 bg-neutral-100 text-neutral-700",
        ],
        tertiary: [
          !disabled && [
            "bg-transparent text-primary-700",
            "hover:text-primary-800 hover:underline",
            "active:text-primary-900 hover:underline",
          ],
          disabled && "text-neutral-700",
        ],
        destructive: [
          "border",
          !disabled && [
            "border-red-700 bg-transparent text-red-700",
            "hover:border-red-800 hover:bg-red-100 hover:text-red-800",
            "active:border-red-900 active:bg-red-200 active:text-red-900",
          ],
          disabled && "border-neutral-400 bg-neutral-100 text-neutral-700",
        ],
      }[baseVariant],
    ),
    text: clsx(
      "select-none truncate whitespace-nowrap",
      "-mb-1 pb-1", // Prevents character tail clipping while preserving the size, alignment, outline, and truncation, for any font
    ),
    icon: clsx(
      "size-5 shrink-0",
      LeftIcon && (hasPadding ? "-ml-2" : "-ml-1"),
      RightIcon && (hasPadding ? "-mr-2" : "-mr-1"),
    ),
  }
}

export const getAsyncButtonClasses = () => ({
  spinner: "w-3.5 h-3.5 !visible absolute inset-0 m-auto",
})
